import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Link } from 'react-router-dom'
import bir from "../img/bir.jpg";
import ikki from "../img/ikki.jpg";
import uch from "../img/uch.jpg";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";


import { Navigation, Pagination } from "swiper";

const Information = () => {
    const [backgarund,setBack] = useState(0);
    const [button,setButton] = useState(false);
    
    const counSwipper = (e) =>{
        console.log(e.snapIndex);
        if(e.snapIndex==1 || e.snapIndex==4){
            setBack(1);
        }
        if(e.snapIndex==2){
            setBack(2);
        }
        if(e.snapIndex==3){
            setBack(3);
            setButton(true);
        }else{
            setButton(false);
        }
    }

    useEffect(() => {
        let button = document.querySelector(".swiper-button-next");
        button.innerHTML = "Keyingisi";
    },[]);
    return (
        <div className="information">
            <div className={`information_glass ${backgarund==2? "animation-2" : ""} ${backgarund==3? "animation-3" : ""} one`}>

            </div>
            <div className={`information_glass ${backgarund==2? "animation-2" : ""} ${backgarund==3? "animation-3" : ""} twoo`}>

            </div>
            <section className="information_section blur">
                <div className="container information_conteiner">
                    <Swiper
                        slidesPerView={1}
                        loop={true}
                        slidesPerGroup={1}
                        pagination={{
                        clickable: true,
                        }}
                        navigation={true}
                        modules={[Pagination, Navigation]}
                        onSlideChange={counSwipper}
                        breakpoints={{
                            0:{
                                slidesPerView:1,
                                slidesPerGroup: 1,
                            },
                            850 : {
                                slidesPerView:1,
                                slidesPerGroup: 1,
                            }
                        }}
                        
                        className="mySwiper"
                    >
                        <SwiperSlide>
                            <div className="swipper_box">
                                <div className="swipper_box-img">
                                    <img src={bir}/>
                                </div>
                                <p>
                                    Surovnomada ishtirok etish uchun guruhingizga ruhsat berilganiga ishonch hosil qiling
                                </p>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className="swipper_box">
                                <div className="swipper_box-img">
                                    <img src={ikki}/>
                                </div>
                                <p>
                                    Iltimos o'qituvchilarga holis baho bering
                                </p>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className="swipper_box">
                                <div className="swipper_box-img">
                                    <img src={uch}/>
                                </div>
                                <p>
                                    Boshlashga tayyormisiz
                                </p>
                            </div>
                        </SwiperSlide>
                        <Link to="/select">
                            <button className={`swiper-button-next ${button? "active" : "none"}`}>Boshlash</button>
                        </Link>
                    </Swiper>
                </div>
            </section>
        </div>    
    );
};


export default Information;